import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractCaseLog } from "../_types/contract-case-log";
import { ContractCaseLogType } from "../_types/contract-case-log-type";

@Injectable({
  providedIn: 'root',
})
export class ContractCaseLogsTypesService extends Service<ContractCaseLogType> {
  public override type = 'contractCaseLogsTypes';
  public override url = 'attendance/contractCaseLogsTypes';
}